"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuFooterLogo = exports.MenuFooterInner = exports.MenuFooter = exports.MenuContainer = exports.MenuBodyContainerWrapper = exports.MenuBodyContainer = exports.MenuBody = exports.LogoContainer = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _constants = require("../../constants");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const LogoContainer = exports.LogoContainer = _styledComponents.default.div.withConfig({
  displayName: "styles__LogoContainer",
  componentId: "sc-1pbtxcy-0"
})(["flex:1;background-size:contain;background-repeat:no-repeat;height:100%;width:100%;"]);
const MenuContainer = exports.MenuContainer = _styledComponents.default.div.withConfig({
  displayName: "styles__MenuContainer",
  componentId: "sc-1pbtxcy-1"
})(["width:", ";background-color:", ";font-family:", ";overflow:visible;-webkit-overflow-scrolling:touch;transition:width 0.3s ease-in-out,z-index 0.3s ease-in-out;display:flex;flex-direction:column;z-index:300;position:absolute;top:", ";bottom:0;left:0;border-right-width:", ";border-right-style:solid;border-right-color:", ";", ";", ";"], ({
  theme
}) => theme.AppFrame.menu.expandedWidth, ({
  theme
}) => theme.colors.appFrame.menu.bg, ({
  theme
}) => theme.fonts.preferred, ({
  hasHeader,
  theme
}) => theme.name === _constants.THEMES.mds && hasHeader ? theme.AppFrame.header.height : 0, ({
  theme
}) => theme.AppFrame.menu.border, ({
  theme
}) => theme.colors.appFrame.menu.borderColor, ({
  theme,
  collapsed
}) => collapsed && (0, _styledComponents.css)(["width:", ";overflow:hidden;"], theme.AppFrame.menu.collapsedWidth), ({
  theme,
  hiddenMenu,
  collapsed
}) => hiddenMenu && (0, _styledComponents.css)(["left:0;transition:left 0.3s ease-in-out;", ";"], collapsed && (0, _styledComponents.css)(["width:", ";left:calc(", " * -1);"], theme.AppFrame.menu.expandedWidth, theme.AppFrame.menu.expandedWidth)));
const MenuBodyContainerWrapper = exports.MenuBodyContainerWrapper = _styledComponents.default.div.withConfig({
  displayName: "styles__MenuBodyContainerWrapper",
  componentId: "sc-1pbtxcy-2"
})(["position:relative;height:100%;flex:1;"]);
const MenuBodyContainer = exports.MenuBodyContainer = _styledComponents.default.div.withConfig({
  displayName: "styles__MenuBodyContainer",
  componentId: "sc-1pbtxcy-3"
})(["overflow-x:hidden;overflow-y:hidden;-webkit-overflow-scrolling:touch;position:absolute;height:100%;width:100%;&:hover{overflow-y:auto;}"]);
const MenuBody = exports.MenuBody = _styledComponents.default.div.withConfig({
  displayName: "styles__MenuBody",
  componentId: "sc-1pbtxcy-4"
})(["margin:16px 0;"]);
const MenuFooter = exports.MenuFooter = _styledComponents.default.div.withConfig({
  displayName: "styles__MenuFooter",
  componentId: "sc-1pbtxcy-5"
})(["padding:0 ", ";overflow:hidden;"], ({
  theme
}) => theme.AppFrame.menu.footer.horizontalPadding);
const MenuFooterInner = exports.MenuFooterInner = _styledComponents.default.div.withConfig({
  displayName: "styles__MenuFooterInner",
  componentId: "sc-1pbtxcy-6"
})(["width:", ";height:60px;"], ({
  theme
}) => `calc(${theme.AppFrame.menu.expandedWidth} - (${theme.AppFrame.menu.footer.horizontalPadding} * 2))`);
const MenuFooterLogo = exports.MenuFooterLogo = _styledComponents.default.div.withConfig({
  displayName: "styles__MenuFooterLogo",
  componentId: "sc-1pbtxcy-7"
})(["border-top-width:1px;border-style:solid;border-color:", ";height:100%;transition:border-color 0.3s ease-in-out;padding:7px 0px 8px 0px;", ";"], ({
  theme
}) => theme.colors.appFrame.menu.line, ({
  collapsed
}) => collapsed && (0, _styledComponents.css)(["border-color:transparent;"]));